import { addInvitee, removeInvitee, updateInvitee } from './actions'

export default function mapDispatchToProps(dispatch) {
    return {
        actions: {
            addInvitee: () => { dispatch(addInvitee()) },
            updateInvitee: (index, invitee) => { dispatch(updateInvitee(index, invitee)) },
            removeInvitee: (index) => { dispatch(removeInvitee(index)) }
        }
    }
}